import React from "react";
import PageHeaderWrapper from "../../components/PageHeaderWrapper";
import { connect } from "react-redux";
import { Card, Drawer, Button, Form, Row, Col, Tooltip } from "antd";
import { TableComp } from "sz-react-utils";
import Request, { LAPI_URL } from "../../request";
import { FormUtils as GetAllFormFields } from "sz-react-utils";
import _ from 'lodash';
import { RightsWrapper } from "../../components/_utils/utils";
import moment from "moment";

const dateFormat = localStorage.getItem('company-details') ? JSON.parse(localStorage.getItem('company-details')).dateFormat : 'DD.MM.YYYY';

const desks = [
    { value: 'Registration Desk', text: 'Registration Desk' },
    { value: 'Application Desk', text: 'Application Desk' },
    { value: 'Visa Desk', text: 'Visa Desk' },
    { value: 'Claim Desk', text: 'Claim Desk' },
    { value: 'Archive Desk', text: 'Archive Desk' }
];

@Form.create()
class ExportDrawer extends React.Component {
    state = {
        visible: true,
        loading: false
    }

    onClose = () => {
        setTimeout(() => {
            this.props.onClose();
        }, 50)
    }

    handleSubmit = (e) => {
        e.preventDefault();
        let { form, exportParams } = this.props;
        form.validateFieldsAndScroll(async (err, valData) => {
            let values = _.clone(valData);
            values.exportParams = exportParams;
            this.setState({ loading: true });
            let response = await Request.exportConsultancyFeeReport(values);
            this.setState({ loading: false });
            if (!response.error) {
                window.open(response.url);
                form.resetFields();
            }
            this.onClose();
        })
    }

    render() {
        let { visible } = this.state;
        let { form: { getFieldDecorator } } = this.props;
        const inputTypes = {
            fields: [
                {
                    label: 'Select Fields',
                    key: 'fields',
                    type: 'select',
                    mode: 'multiple',
                    showSearch: true,
                    required: true,
                    options: [
                        { id: 'id', display: 'VID' },
                        { id: 'studentName', display: 'Student Name' },
                        { id: 'registrationDesk.registrationDate', display: 'Registration Date' },
                        { id: 'counsellorId.name', display: 'Counsellor' },
                        { id: 'atLevel', display: 'Desk' },
                        { id: 'registrationDesk.countryName', display: 'Country' },
                        { id: 'registrationDesk.total', display: 'Total Consultancy' },
                        { id: 'registrationDesk.paid', display: 'Paid Consultancy' },
                        { id: 'registrationDesk.balance', display: 'Pending Consultancy' },
                    ],
                    onChange: v => {
                        this.props.form.setFieldsValue({ fields: v });
                    },
                }

            ]
        }
        return (
            <Drawer
                title="Export Consultancy Fee Report"
                placement="right"
                closable={true}
                onClose={this.onClose}
                visible={visible}
                width={500}
            >
                <Card bordered={true}>
                    <Form onSubmit={this.handleSubmit}>
                        <GetAllFormFields
                            apiurl={LAPI_URL}
                            inputSchema={inputTypes}
                            getFieldDecorator={getFieldDecorator}
                        />
                        <Row style={{ marginTop: '20px' }}>
                            <Col span={8} />
                            <Col span={8}>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    style={{ marginBottom: 10 }}
                                    loading={this.state.loading}>
                                    Save
                                </Button>
                            </Col>
                            <Col span={8} />
                        </Row>
                    </Form>
                </Card>
            </Drawer>
        )
    }
}

class ConsultancyFeeReport extends React.Component {
    state = {
        count: 0,
        exportParams: {},
        showExportDrawer: false,
        countriesData: [],
        counsellorsArr: [],
    }


    constructor(props) {
        super(props)
        this.table = React.createRef()
    }

    loadCountries = () => {
        Request.getCountriesWithoutAuth({
            results: 200,
            sortField: 'countryName',
            sortOrder: 'ascend'
        })
            .then(resp => {
                resp.data = resp.data.reduce((temp, vv) => {
                    temp.push({ value: vv._id, text: vv.countryName });
                    return temp
                }, [])

                this.setState({ countriesData: resp.data });
            })
            .catch(err => {
                console.log(err)
            })
    }


    loadCounsellors = async () => {
        let { data } = await Request.loadAllCounsellors();
        data = data.reduce((temp, vv) => {
            temp.push({ value: vv._id, text: vv.name });
            return temp;
        }, [])
        this.setState({ counsellorsArr: data })
    }


    componentDidMount() {
        this.loadCountries();
        this.loadCounsellors();
    }

    apiRequest = (params) => {
        return new Promise(async (resolve) => {
            this.setState({ exportParams: params });
            let response = await Request.getConsultancyFeeReport(params);
            this.setState({ count: response.total });
            resolve(response);
        })
    }


    exportConsultancyFee = () => {
        this.setState({ showExportDrawer: true });
    }

    closeExportDrawer = () => {
        this.setState({ showExportDrawer: false }, () => {
            this.table.current.reload();
        })
    }

    render() {
        let { count, showExportDrawer } = this.state;
        const columns = [
            {
                title: 'Sr. No',
                key: 'serialNumber',
                width: 60,
                render: (text, record, index) => (
                    <div>{index + 1}</div>
                )
            },
            {
                title: 'Action',
                key: 'operation',
                width: 60,
                render: (text, record) => (
                    <>
                        <Tooltip title="View Student Profile">
                            <Button icon="eye" shape="round" size="small" onClick={() => window.open(`/inquiry/studentProfileDetails?id=${record._id}`)}></Button>
                        </Tooltip>
                    </>
                )
            },
            {
                title: 'V.I.D',
                key: 'id',
                searchTextName: 'VID',
                width: 100,
            },
            {
                title: 'Student Name',
                key: 'studentName',
                searchTextName: 'Student Name'
            },
            {
                title: 'Registration Date',
                key: 'registrationDesk.registrationDate',
                render: (text, record) => (
                    <div>{moment(record.registrationDesk.registrationDate).format(dateFormat)}</div>
                )
            },
            {
                title: 'Desk',
                key: 'atLevel',
                filters: desks,
                render: (text, record) => (
                    <div>{record.atLevel === "Front Desk" ? "Counselling Desk" : record.atLevel}</div>
                )
            },
            {
                title: 'Counsellor',
                key: 'counsellorId',
                dataIndex: 'counsellorId.name',
                filters: this.state.counsellorsArr,
            },
            {
                title: 'Country',
                key: 'countryId',
                dataIndex: 'registrationDesk.countryName',
                filters: this.state.countriesData,
            },
            {
                title: 'Total Consultancy',
                key: 'registrationDesk.total'
            },
            {
                title: 'Consultancy Paid',
                key: 'registrationDesk.paid'
            },
            {
                title: 'Consultancy Pending',
                key: 'registrationDesk.balance'
            },


        ];
        return (
            <PageHeaderWrapper title={`Consultancy Fee Report- ${count}`}>
                {
                    showExportDrawer ?
                        <ExportDrawer exportParams={this.state.exportParams} onClose={this.closeExportDrawer} />
                        : null
                }
                <Card bordered={true}>
                    <RightsWrapper myRight={"consultancyFeeReportExport.view"}>
                        <Button type="primary" onClick={this.exportConsultancyFee}>Export Excel</Button>
                    </RightsWrapper>
                </Card>
                <Card bordered={true}>
                    <TableComp
                        columns={columns}
                        showSelector={true}
                        ref={this.table}
                        apiRequest={this.apiRequest}
                        extraProps={{ scroll: { x: 1000 } }}
                        pagination={{
                            showSizeChanger: true,
                            defaultPageSize: 10,
                            pageSizeOptions: ["10", "20", "50", "100", "1000"],
                        }}
                    />
                </Card>
            </PageHeaderWrapper>
        )
    }
}


const mapStateToProps = ({ global }) => ({
    categories: global.categories,
    loading: global.buttonLoading
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ConsultancyFeeReport)